import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const positiveNumberValidator = (maxValue: number): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined) {
      return { required: true };
    }

    if (isNaN(Number(value))) {
      return { invalidNumber: true };
    }

    if (Number(value) <= 0) {
      return { nonPositive: true };
    }

    if (Number(value) > maxValue) {
      control.setValue(maxValue);
      return { maxExceeded: { maxValue: maxValue, actualValue: value } };
    }

    return null;
  };
